import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class LoggingMessage extends WebViewMessage {
  public constructor(
    public severity: string | undefined,
    public timestamp: string | undefined,
    public message: string | undefined,
  ) {
    super(MessageType.LoggingMessage);
  }
}
